/**
 * Kitchen Station Page
 * KDS display for chef to prepare meals
 * Uses shared KDSStationLayout with auto-reconnect and offline caching
 */
import { ChefHat } from 'lucide-react';
import KDSStationLayout from '@/components/kds/KDSStationLayout';

export default function KitchenStationPage() {
  return (
    <KDSStationLayout
      station="kitchen"
      stationName="Kitchen Station"
      stationIcon={ChefHat}
      iconColorClass="bg-gradient-to-br from-orange-500 to-orange-600"
      defaultDeviceId="KDS-KIT-01"
    />
  );
}
